import type { PublicacaoDto } from "@base/contracts";
import { ChevronDown, RotateCcw } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  IconePlataforma,
  ROTULO_PLATAFORMA,
} from "../../../shared/branding/icone-plataforma";

type Props = {
  readonly itens: readonly PublicacaoDto[];
  readonly disabled?: boolean;
  readonly onEscolher: (ids: readonly string[]) => void;
};

/**
 * Uma rede: reprocessa na hora. Varias: menu com Todas ou uma rede.
 */
export function BotaoReprocessarFalha({
  itens,
  disabled = false,
  onEscolher,
}: Props) {
  if (itens.length <= 1) {
    const unica = itens[0];
    return (
      <Button
        type="button"
        variant="outline"
        className="cursor-pointer"
        disabled={disabled || !unica}
        onClick={() => {
          if (unica) onEscolher([unica.id]);
        }}
      >
        <RotateCcw className="size-4" aria-hidden />
        Reprocessar
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="cursor-pointer"
          disabled={disabled}
          aria-label="Reprocessar: todas ou uma rede"
        >
          <RotateCcw className="size-4" aria-hidden />
          Reprocessar
          <ChevronDown className="size-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="z-[300] min-w-52 p-1.5">
        <DropdownMenuLabel className="px-2 py-2 text-sm font-medium">
          Qual rede?
        </DropdownMenuLabel>
        <DropdownMenuItem
          className="cursor-pointer py-3"
          onClick={() => onEscolher(itens.map((p) => p.id))}
        >
          Todas as redes
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {itens.map((p) => (
          <DropdownMenuItem
            key={p.id}
            className="cursor-pointer py-3"
            onClick={() => onEscolher([p.id])}
          >
            <IconePlataforma
              plataforma={p.plataforma}
              tom="falha"
              className="size-3.5"
            />
            {ROTULO_PLATAFORMA[p.plataforma]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
